/**
 * @generated SignedSource<<4150d4785693a4a17d5917faadea2e3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ChargeUpdatedStatusInput = {
  chargeId?: string | null | undefined;
  clientSubscriptionId?: string | null | undefined;
};
export type ChargeUpdatedStatusSubscription$variables = {
  input: ChargeUpdatedStatusInput;
};
export type ChargeUpdatedStatusSubscription$data = {
  readonly ChargeUpdatedStatus: {
    readonly charge: {
      readonly id: string;
      readonly status: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ChargeUpdatedStatusSubscription = {
  response: ChargeUpdatedStatusSubscription$data;
  variables: ChargeUpdatedStatusSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChargeUpdatedStatusPayload",
    "kind": "LinkedField",
    "name": "ChargeUpdatedStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Charge",
        "kind": "LinkedField",
        "name": "charge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChargeUpdatedStatusSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChargeUpdatedStatusSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a49908d0939e13d55ab2057688308067",
    "id": null,
    "metadata": {},
    "name": "ChargeUpdatedStatusSubscription",
    "operationKind": "subscription",
    "text": "subscription ChargeUpdatedStatusSubscription(\n  $input: ChargeUpdatedStatusInput!\n) {\n  ChargeUpdatedStatus(input: $input) {\n    charge {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f5ad488f0b2b04bfb37b77cbf64acd6";

export default node;
